/**
 * Theme initialization without authentication dependencies
 * This script provides fallback functionality for the Shrine theme
 */

(function() {
  'use strict';

  // Initialize theme components when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    console.log('Theme initialization started');

    // Ensure all sections are visible
    ensureSectionsVisible();

    // Initialize sliders if Splide is available
    initializeSliders();

    // Initialize other components
    initializeSections();
    initializeProducts();
    initializeCart();

    console.log('Theme initialization completed');
  });

  function ensureSectionsVisible() {
    // Force visibility on all important elements
    const elements = document.querySelectorAll('main, .content-for-layout, .shopify-section, .section');
    elements.forEach(element => {
      element.style.visibility = 'visible';
      element.style.opacity = '1';
      element.style.display = 'block';
    });

    // Remove any hiding classes
    document.querySelectorAll('.animate-section.animate--hidden').forEach(section => {
      section.classList.add('animate--shown');
      section.classList.remove('animate--hidden');
    });
  }

  function initializeSliders() {
    // Initialize Splide sliders if library is available
    if (typeof Splide !== 'undefined') {
      document.querySelectorAll('.splide').forEach(function(slider) {
        try {
          new Splide(slider).mount();
        } catch (error) {
          console.log('Slider initialization skipped:', error.message);
        }
      });
    }

    // Initialize custom slider components
    document.querySelectorAll('slider-component').forEach(slider => {
      if (slider.initPages && typeof slider.initPages === 'function') {
        slider.initPages();
      }
    });
  }

  function initializeSections() {
    // Initialize section-specific functionality

    // Handle accordions
    document.querySelectorAll('details').forEach(details => {
      details.addEventListener('toggle', function() {
        if (this.open) {
          // Close other accordions in the same group if needed
          const group = this.closest('.accordion-group');
          if (group) {
            group.querySelectorAll('details[open]').forEach(other => {
              if (other !== this) other.open = false;
            });
          }
        }
      });
    });

    // Handle modals
    document.querySelectorAll('[data-modal]').forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        const modalId = this.getAttribute('data-modal');
        const modal = document.querySelector(modalId);
        if (modal && modal.show) {
          modal.show(this);
        }
      });
    });
  }

  function initializeProducts() {
    // Initialize product-specific functionality

    // Handle product forms
    document.querySelectorAll('product-form').forEach(form => {
      // Ensure form is functional
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn && !submitBtn.disabled) {
        submitBtn.style.opacity = '1';
        submitBtn.style.pointerEvents = 'auto';
      }
    });

    // Handle variant selection
    document.querySelectorAll('variant-selects').forEach(variantSelect => {
      if (variantSelect.updateOptions && typeof variantSelect.updateOptions === 'function') {
        variantSelect.updateOptions();
      }
    });
  }

  function initializeCart() {
    // Initialize cart functionality

    // Ensure cart drawer is functional
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.style.display = 'block';
    }

    // Handle cart notifications
    document.querySelectorAll('cart-notification').forEach(notification => {
      notification.style.display = 'block';
    });
  }

  // Fallback for missing global functions
  window.themeInitialized = true;

  // Additional fallbacks for Shopify-specific functionality
  if (!window.Shopify) {
    window.Shopify = {
      designMode: false,
      theme: { name: 'Shrine PRO' }
    };
  }

  // Ensure accessibility strings are available
  if (!window.accessibilityStrings) {
    window.accessibilityStrings = {
      imageAvailable: 'Image [index] available',
      shareSuccess: 'Link copied to clipboard',
      pauseSlideshow: 'Pause slideshow',
      playSlideshow: 'Play slideshow'
    };
  }

})();